import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

import { Capacitor } from "@capacitor/core";
import { StatusBar } from "@capacitor/status-bar";

if (Capacitor.isNativePlatform()) {
  StatusBar.setOverlaysWebView({ overlay: false });
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)